export interface Chapter {
  id: string;
  number: number;
  title: string;
  pageCount: number;
  createdAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  chapters: Chapter[];
  status: 'ongoing' | 'completed';
  views: number;
  rating: number;
  updatedAt: string;
  createdAt: string;
}

export const comics: Comic[] = [
  {
    id: '1',
    title: '星光之恋',
    author: '金智秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20a%20beautiful%20young%20couple%20under%20starry%20night%20sky%2C%20soft%20watercolor%20style%2C%20warm%20pink%20and%20purple%20tones%2C%20dreamy%20atmosphere%2C%20romantic%20illustration%2C%20clean%20simple%20background%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    description: '在首尔的繁华街头，李星辰遇见了改变她一生的那个人。一段跨越身份与距离的浪漫爱情故事就此展开。当星光闪烁的夜晚，两颗心逐渐靠近，他们能否克服重重阻碍，找到属于彼此的温暖？',
    category: 'romance',
    tags: ['恋爱', '都市', '治愈'],
    chapters: [
      { id: 'c1-1', number: 1, title: '命运的相遇', pageCount: 45, createdAt: '2026-08-01' },
      { id: 'c1-2', number: 2, title: '心动的瞬间', pageCount: 42, createdAt: '2026-08-02' },
      { id: 'c1-3', number: 3, title: '靠近的距离', pageCount: 40, createdAt: '2026-08-03' },
      { id: 'c1-4', number: 4, title: '不期而遇', pageCount: 38, createdAt: '2026-08-04' },
    ],
    status: 'ongoing',
    views: 1285000,
    rating: 4.8,
    updatedAt: '2026-08-04',
    createdAt: '2026-07-15',
  },
  {
    id: '2',
    title: '异界魔法师',
    author: '朴俊赫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20a%20powerful%20mage%20with%20glowing%20magical%20staff%20in%20a%20mystical%20forest%2C%20epic%20fantasy%20illustration%2C%20dramatic%20lighting%2C%20detailed%20magical%20effects%2C%20dark%20mysterious%20atmosphere%2C%20webtoon%20cover%20style&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    description: '普通高中生林焕在一次意外中穿越到了魔法世界。在这里，他发现自己拥有前所未有的魔法天赋。面对强大的黑暗势力，他必须快速成长，保护这个新世界的和平。',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '成长'],
    chapters: [
      { id: 'c2-1', number: 1, title: '穿越异界', pageCount: 50, createdAt: '2026-07-28' },
      { id: 'c2-2', number: 2, title: '魔法觉醒', pageCount: 48, createdAt: '2026-07-30' },
      { id: 'c2-3', number: 3, title: '初入学院', pageCount: 46, createdAt: '2026-08-02' },
    ],
    status: 'ongoing',
    views: 2150000,
    rating: 4.9,
    updatedAt: '2026-08-02',
    createdAt: '2026-07-10',
  },
  {
    id: '3',
    title: '格斗之王',
    author: '崔民浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20a%20muscular%20fighter%20in%20dynamic%20fighting%20pose%2C%20intense%20martial%20arts%20scene%2C%20bold%20dramatic%20illustration%2C%20red%20and%20black%20color%20scheme%2C%20powerful%20energy%20effects%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    description: '曾经的格斗冠军姜泰宇因伤退役后，在地下格斗场重新崛起。每一次出拳都是对命运的抗争，每一场胜利都是对过去的超越。这是一部关于勇气与决心的热血韩漫。',
    category: 'action',
    tags: ['动作', '热血', '竞技'],
    chapters: [
      { id: 'c3-1', number: 1, title: '王者归来', pageCount: 55, createdAt: '2026-07-20' },
      { id: 'c3-2', number: 2, title: '地下擂台', pageCount: 52, createdAt: '2026-07-25' },
      { id: 'c3-3', number: 3, title: '宿敌登场', pageCount: 50, createdAt: '2026-07-30' },
      { id: 'c3-4', number: 4, title: '生死之战', pageCount: 48, createdAt: '2026-08-03' },
      { id: 'c3-5', number: 5, title: '新的开始', pageCount: 45, createdAt: '2026-08-04' },
    ],
    status: 'ongoing',
    views: 980000,
    rating: 4.7,
    updatedAt: '2026-08-04',
    createdAt: '2026-06-20',
  },
  {
    id: '4',
    title: '迷雾追踪',
    author: '郑恩雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20a%20detective%20in%20dark%20rainy%20alley%2C%20mysterious%20silhouette%20in%20fog%2C%20noir%20atmosphere%2C%20suspenseful%20illustration%2C%20cold%20blue%20gray%20tones%2C%20dramatic%20shadows%2C%20webtoon%20cover%20style&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    description: '首尔发生了一系列离奇失踪案件，刑警韩秀妍深入调查后发现，这些案件背后隐藏着一个惊天秘密。迷雾重重中，真相究竟在何处？悬疑推理爱好者必读之作。',
    category: 'thriller',
    tags: ['悬疑', '推理', '犯罪'],
    chapters: [
      { id: 'c4-1', number: 1, title: '失踪之谜', pageCount: 40, createdAt: '2026-07-18' },
      { id: 'c4-2', number: 2, title: '第二条线索', pageCount: 38, createdAt: '2026-07-22' },
    ],
    status: 'ongoing',
    views: 756000,
    rating: 4.6,
    updatedAt: '2026-07-22',
    createdAt: '2026-07-01',
  },
  {
    id: '5',
    title: '搞笑一家人',
    author: '李尚贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20a%20funny%20family%20with%20exaggerated%20expressions%2C%20bright%20colorful%20illustration%2C%20humorous%20cartoon%20style%2C%20warm%20yellow%20and%20orange%20tones%2C%20playful%20atmosphere%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    description: '金氏一家四口的爆笑日常！从妈妈的神奇料理到爸爸的搞笑舞步，从姐姐的恋爱糗事到弟弟的校园趣事，每一话都让你笑到停不下来，轻松减压必备漫画！',
    category: 'comedy',
    tags: ['搞笑', '日常', '家庭'],
    chapters: [
      { id: 'c5-1', number: 1, title: '妈妈的新菜', pageCount: 30, createdAt: '2026-07-25' },
      { id: 'c5-2', number: 2, title: '爸爸的减肥计划', pageCount: 32, createdAt: '2026-07-28' },
      { id: 'c5-3', number: 3, title: '姐姐的秘密', pageCount: 28, createdAt: '2026-08-01' },
    ],
    status: 'ongoing',
    views: 620000,
    rating: 4.5,
    updatedAt: '2026-08-01',
    createdAt: '2026-07-05',
  },
  {
    id: '6',
    title: '时光深处的你',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20a%20melancholic%20woman%20looking%20at%20old%20photographs%2C%20emotional%20drama%20illustration%2C%20soft%20nostalgic%20atmosphere%2C%20warm%20sepia%20tones%2C%20delicate%20detailed%20art%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    description: '三十岁的林智雅收到了一封来自过去的信。写信的人，是十年前离开的青梅竹马。当她按照信中的线索寻找时，一段尘封的记忆被重新唤醒。感人至深的剧情韩漫。',
    category: 'drama',
    tags: ['剧情', '回忆', '感动'],
    chapters: [
      { id: 'c6-1', number: 1, title: '神秘的信', pageCount: 42, createdAt: '2026-07-15' },
      { id: 'c6-2', number: 2, title: '十年前的约定', pageCount: 40, createdAt: '2026-07-20' },
      { id: 'c6-3', number: 3, title: '寻找的旅程', pageCount: 38, createdAt: '2026-07-25' },
      { id: 'c6-4', number: 4, title: '重逢', pageCount: 44, createdAt: '2026-08-03' },
    ],
    status: 'completed',
    views: 1890000,
    rating: 4.9,
    updatedAt: '2026-08-03',
    createdAt: '2026-06-01',
  },
  {
    id: '7',
    title: '暗夜传说',
    author: '尹志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20art%2C%20a%20ghostly%20figure%20in%20an%20abandoned%20school%20at%20night%2C%20eerie%20atmosphere%2C%20dark%20shadowy%20illustration%2C%20cold%20blue%20and%20black%20tones%2C%20horror%20webtoon%20style%2C%20creepy%20vintage%20feel&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    description: '一所废弃的学校每到午夜就会传出奇怪的声音。一群勇敢的高中生决定一探究竟，却发现自己踏入了一个超出想象的恐怖世界。每一夜，都有新的恐怖传说诞生。',
    category: 'horror',
    tags: ['恐怖', '校园', '超自然'],
    chapters: [
      { id: 'c7-1', number: 1, title: '午夜钟声', pageCount: 48, createdAt: '2026-07-22' },
      { id: 'c7-2', number: 2, title: '废弃教室', pageCount: 45, createdAt: '2026-07-28' },
    ],
    status: 'ongoing',
    views: 450000,
    rating: 4.4,
    updatedAt: '2026-07-28',
    createdAt: '2026-07-08',
  },
  {
    id: '8',
    title: '猫与咖啡屋',
    author: '申美玲',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20a%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20a%20gentle%20barista%2C%20warm%20pastel%20colors%2C%20relaxing%20atmosphere%2C%20soft%20illustration%20style%2C%20healing%20vibes%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    description: '在首尔的一条安静小巷里，有一家名为"猫与咖啡屋"的小店。店主素妍和她的六只猫，每天都会迎来不同的客人。一杯咖啡，一只猫咪，一段温暖的故事。',
    category: 'slice-of-life',
    tags: ['日常', '治愈', '猫咪'],
    chapters: [
      { id: 'c8-1', number: 1, title: '第一位客人', pageCount: 35, createdAt: '2026-07-20' },
      { id: 'c8-2', number: 2, title: '流浪猫的故事', pageCount: 33, createdAt: '2026-07-25' },
      { id: 'c8-3', number: 3, title: '下雨天的来客', pageCount: 36, createdAt: '2026-08-02' },
    ],
    status: 'ongoing',
    views: 520000,
    rating: 4.7,
    updatedAt: '2026-08-02',
    createdAt: '2026-07-01',
  },
  {
    id: '9',
    title: '武林至尊',
    author: '张太贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%20art%2C%20a%20swordsman%20on%20a%20mountain%20peak%20at%20sunset%2C%20epic%20oriental%20fantasy%20illustration%2C%20traditional%20ink%20painting%20style%2C%20dramatic%20orange%20and%20gold%20tones%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    description: '在一个武侠世界，少年秦风从无名小卒一步步成长为武林至尊。江湖恩怨、门派斗争、绝世武功，一部融合传统武侠与韩漫画风的史诗巨作。',
    category: 'action',
    tags: ['武侠', '江湖', '成长'],
    chapters: [
      { id: 'c9-1', number: 1, title: '少年初入江湖', pageCount: 52, createdAt: '2026-07-10' },
      { id: 'c9-2', number: 2, title: '初遇名师', pageCount: 50, createdAt: '2026-07-18' },
      { id: 'c9-3', number: 3, title: '第一场对决', pageCount: 48, createdAt: '2026-07-26' },
    ],
    status: 'ongoing',
    views: 1450000,
    rating: 4.8,
    updatedAt: '2026-07-26',
    createdAt: '2026-06-15',
  },
  {
    id: '10',
    title: '恶魔契约',
    author: '徐振宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20cover%20art%2C%20a%20character%20making%20a%20pact%20with%20a%20shadow%20demon%2C%20gothic%20dark%20atmosphere%2C%20intricate%20illustration%2C%20purple%20and%20black%20mystical%20tones%2C%20dramatic%20composition%2C%20webtoon%20cover%20style&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    description: '为了拯救病危的妹妹，韩镇宇与恶魔签订了一份危险的契约。他获得了强大的力量，但代价是逐渐失去自己的人性。在光明与黑暗之间，他将如何抉择？',
    category: 'fantasy',
    tags: ['暗黑', '契约', '抉择'],
    chapters: [
      { id: 'c10-1', number: 1, title: '绝望中的选择', pageCount: 48, createdAt: '2026-07-12' },
      { id: 'c10-2', number: 2, title: '力量的代价', pageCount: 46, createdAt: '2026-07-18' },
      { id: 'c10-3', number: 3, title: '内心的斗争', pageCount: 44, createdAt: '2026-07-25' },
      { id: 'c10-4', number: 4, title: '抉择的时刻', pageCount: 42, createdAt: '2026-08-01' },
    ],
    status: 'ongoing',
    views: 1120000,
    rating: 4.7,
    updatedAt: '2026-08-01',
    createdAt: '2026-06-25',
  },
  {
    id: '11',
    title: '初恋这件小事',
    author: '金智秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20two%20high%20school%20students%20sharing%20earphones%20on%20a%20sunny%20afternoon%2C%20sweet%20youthful%20atmosphere%2C%20soft%20pastel%20pink%20and%20blue%20tones%2C%20gentle%20illustration%20style%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    description: '高二学生韩素熙暗恋隔壁班的学霸已经一年了。当她终于鼓起勇气告白时，却发现对方也一直在偷偷关注她。一段纯真美好的校园初恋故事由此展开。',
    category: 'romance',
    tags: ['校园', '初恋', '甜蜜'],
    chapters: [
      { id: 'c11-1', number: 1, title: '暗恋的365天', pageCount: 38, createdAt: '2026-07-15' },
      { id: 'c11-2', number: 2, title: '意外的发现', pageCount: 36, createdAt: '2026-07-22' },
      { id: 'c11-3', number: 3, title: '鼓起勇气', pageCount: 40, createdAt: '2026-08-01' },
    ],
    status: 'ongoing',
    views: 870000,
    rating: 4.6,
    updatedAt: '2026-08-01',
    createdAt: '2026-07-01',
  },
  {
    id: '12',
    title: '校园怪谈',
    author: '郑恩雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20horror%20cover%20art%2C%20students%20in%20a%20dark%20school%20corridor%20with%20flickering%20lights%2C%20suspenseful%20atmosphere%2C%20cold%20dark%20green%20tones%2C%20creepy%20illustration%20style%2C%20mysterious%20shadows%2C%20webtoon%20cover%20aesthetic&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    description: '每一所学校都有自己的怪谈传说。但当怪谈变成现实，学生们一个接一个地消失时，剩下的幸存者必须找出真相。恐怖与推理完美结合的惊悚韩漫。',
    category: 'horror',
    tags: ['校园', '怪谈', '推理'],
    chapters: [
      { id: 'c12-1', number: 1, title: '第一个怪谈', pageCount: 44, createdAt: '2026-07-10' },
      { id: 'c12-2', number: 2, title: '消失的同学', pageCount: 42, createdAt: '2026-07-17' },
    ],
    status: 'ongoing',
    views: 680000,
    rating: 4.5,
    updatedAt: '2026-07-17',
    createdAt: '2026-06-28',
  },
];

export function getComicsByCategory(categorySlug: string): Comic[] {
  return comics.filter((comic) => comic.category === categorySlug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((comic) => comic.id === id);
}

export function getPopularComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getRecommendedComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
}